import {Progress,Divider} from "@nextui-org/react";
import ProjectComponent from "../../components/Project/ProjectComponent";
import areaPhoto from '../../assets/photos/area.webp';
import area2Photo from '../../assets/photos/area2.webp';
import gabar1 from '../../assets/photos/gabar/gabar1.webp';
import gabar2 from '../../assets/photos/gabar/gabar2.webp';
import gabar3 from '../../assets/photos/gabar/gabar3.webp';
import gabar4 from '../../assets/photos/gabar/gabar4.webp';
import gabar5 from '../../assets/photos/gabar/gabar5.webp';
import gabar6 from '../../assets/photos/gabar/gabar6.webp';
import gabar7 from '../../assets/photos/gabar/gabar7.webp';
import syol1 from "../../assets/photos/syol/syol1.jpg"
import oiltrt1 from '../../assets/photos/gabar/oiltrt1-cmp.webp';

import {useTranslation} from "react-i18next";

const ProjectsPage = () => {
    const {t} = useTranslation();
    
    const projects = [
        {
            title: t("projectDetails.gabar.title"),
            desc: t("projectDetails.gabar.desc"),
            year: t("projectDetails.gabar.year"),
            images: [oiltrt1,gabar1, gabar2, gabar3,gabar4,gabar5,gabar6,gabar7,areaPhoto,area2Photo]
        },
        {
            title: t("projectDetails.iraq.title"),
            desc: t("projectDetails.iraq.desc"),
            year: t("projectDetails.iraq.year"),
            images: ["https://lh3.googleusercontent.com/p/AF1QipMIpwKLETCQOssnVDIJlV3JJGVfSMBLxgOZ8gI4=s1360-w1360-h1020","https://lh3.googleusercontent.com/p/AF1QipP_trDHsNTyWY6XxAemscB1W0KZSPOgsvgdjCs6=s1360-w1360-h1020"]
        },
        {
            title: t("projectDetails.syol.title"),
            desc: t("projectDetails.syol.desc"),
            year: t("projectDetails.syol.year"),
            images: [syol1]
        }
    ];
    
    return (
        <main>
            <article className="min-h-screen bg-gradient-to-b from-background to-default-100">
                <section className="bg-white dark:bg-gray-900 bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')]">
                    <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16">
                        <div className="text-center mb-16">
                            <h2 className="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl">
                                {t("projects")}
                            </h2>
                            <div className="flex justify-center my-5">
                                <Progress
                                    size="sm"
                                    color="success"
                                    isIndeterminate
                                    aria-label="Loading..."
                                    className="max-w-md"
                                />
                            </div>
                            <p className="mb-8 text-lg font-normal lg:text-xl max-w-4xl mx-auto">
                                {t("projectsDesc")}
                            </p>
                            <Divider className="my-4" />
                        </div>
                    </div>
                </section>

                <div className="space-y-16">
                    {projects.map((project, index) => (
                        <section key={index}>
                            <h3 className="sr-only">{project.title}</h3>
                            <ProjectComponent
                                title={project.title}
                                desc={project.desc}
                                year={project.year}
                                images={project.images}
                            />
                        </section>
                    ))}
                </div>
            </article>
        </main>
    );
};

export default ProjectsPage;